import { BaseDto } from './base.dto';
import { MerchantPaymentMethodDto } from './merchantPaymentMethod.dto';

export class MerchantPaymentMethodOptionDto extends BaseDto {
  description: string;
  enabled: boolean;
  amount: number;
  merchantPaymentMethod: MerchantPaymentMethodDto;
  sequence: number;
  enableAmountOverride: boolean;
}
